<!--
* @description  参数1
* @fileName  index
* @author userName
* @date 2023-12-26 11:58:55
!-->
<template>
  <div id="commodities" class="commodities">
    <div class="commodities-title">
      商品信息
    </div>
    <div class="main-info p24 check-price-form">
      <el-form
        ref="formData"
        :model="formData"
        :rules="allRules"
        label-position="top"
        size="medium"
        class="item-Surcharge"
        @submit.native.prevent
      >
        <div class="new_inquiry_header item-Surcharge_search">
          <el-form-item class="flex-width_1" prop="productName" label="商品名称" label-width="48%">
            <el-input v-model="formData.productName" />
          </el-form-item>
          <el-form-item class="flex-width_1" prop="skuCode" label="SKU (选填)" label-width="48%">
            <el-input v-model="formData.skuCode" />
          </el-form-item>
          <el-form-item
            class="flex-width_1"
            prop="description"
            label="商品描述"
            label-width="100%"
          >
            <el-input v-model="formData.description" />
          </el-form-item>
          <el-form-item class="flex-width_1" prop="endUse" label="用途">
            <el-input v-model="formData.endUse" />
          </el-form-item>
          <el-form-item
            class="flex-width_1"
            prop="countryId"
            label="生产国家"
            label-width="48%"
          >
            <el-select
              v-model="formData.countryId"
              popper-class="cargo_info_select"
              clearable
              filterable
              placeholder="选择生产国家"
            >
              <el-option
                v-for="(item, index) in countryList"
                :key="index"
                :value="item.code"
                :label="item.code+'-'+item.nameEn"
              />
            </el-select>
          </el-form-item>
          <el-form-item class="flex-width_1" prop="url" label="产品链接(选填)">
            <el-input v-model="formData.url" />
          </el-form-item>
          <el-form-item class="flex-width_1" prop="HSorHTSCode" label="海关编码(选填)">
            <el-input v-model="formData.HSorHTSCode" />
          </el-form-item>
          <el-form-item class="flex-width_1" prop="" label="商品图片和文件 (选填)">
            添加诸如产品规格、FDA数据表等附加文档，许可证、政府机构表格和照片将帮助您报关员更准确地对您的产品进行分类。
          </el-form-item>
          <el-form-item class="flex-width_1" prop="image" label="">
            <el-upload
              ref="upload"
              class="upload"
              :action="uploadAction"
              :on-success="(response, file, fileList) => handleSuccess(response, file, fileList,1)"
              :multiple="false"
              :limit="1"
              accept=".jpg,.jpeg,.png,.bmp,.gif"
            >
              <div class="upload-class">
                <img
                  src="../../../../../../../assets/img/manage/settings/上传.png"
                  width="24px"
                  height="24px"
                >
                <div class="upload-label">
                  <span>上传商品图片</span>
                  <span>（大小不超过7MB）</span>
                </div>
                <img
                  src="../../../../../../../assets/img/manage/settings/pic_com_pic.png"
                  width="115px"
                  height="70px"
                >
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item class="flex-width_1" prop="document" label="">
            <el-upload
              ref="upload"
              class="upload"
              :action="uploadAction"
              :on-success="(response, file, fileList) => handleSuccess(response, file, fileList,2)"
              multiple
              :limit="9"
              accept=".jpg,.jpeg,.gif,.png,.bmp,.pic,.doc,.docx,.rar,.xls,.xlsx,.pdf,.zip"
            >
              <div class="upload-class">
                <img
                  src="../../../../../../../assets/img/manage/settings/上传.png"
                  width="24px"
                  height="24px"
                >
                <div class="upload-label">
                  <span>上传商品文件</span>
                  <span>（大小不超过7MB）</span>
                </div>
                <img
                  src="../../../../../../../assets/img/manage/settings/pic_com_doc.png"
                  width="115px"
                  height="70px"
                >
              </div>
            </el-upload>
          </el-form-item>
        </div>
      </el-form>
      <div class="foot-button-manage">
        <div>
          <button class="by-common--primary" @click="clickCancel">取消</button>
          <button class="by-button--primary" :loading="btnLoading" @click="clickSave">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import define from '@/utils/define'
import request from '@/utils/request'
import {
  getCookie
} from '@/utils/cookiejs'
export default {
  name: 'Index',
  components: {
    // 组件的引用
  },
  props: {},
  data() {
    var checkEmpty = (rule, value, callback) => {
      if (rule.required === false) {
        callback()
        return false
      }
      if (!value) {
        if (rule.fullField == 'StartCityKey') {
          this.isCol1 = true
        } else {
          this.isCol1 = false
        }

        document.documentElement.scrollTop = 0
        return callback(new Error('请输入'))
      } else {
        callback()
      }
    }
    return {
      formData: {
        id: '',
        productName: '',
        skuCode: '',
        description: '',
        endUse: '',
        countryId: undefined,
        url: '',
        HSorHTSCode: '',
        productImage: undefined,
        productFile: undefined
      },
      allRules: {
        productName: [{
          required: true,
          validator: checkEmpty,
          trigger: 'change'
        }],
        description: [{
          required: true,
          validator: checkEmpty,
          trigger: 'change'
        }],
        endUse: [{
          required: true,
          validator: checkEmpty,
          trigger: 'change'
        }],
        countryId: [{
          required: true,
          validator: checkEmpty,
          trigger: 'change'
        }]
      },
      countryList: [],
      token: '',
      visible: false,
      btnLoading: false,
      uploadAction: ''
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
    this.uploadAction = define.comUrl + '/api/file/Uploader/customer'
    this.token = getCookie('token')
    if (this.token) {
      this.getCountry()
    }
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    handleSuccess(response, file, fileList, type) {
      if (response.code === 200) {
        if (type === 1) {
          if (!this.formData.productImage) {
            this.formData.productImage = []
          }
          this.formData.productImage.push({
            name: file.name,
            fileId: response.data.name,
            url: response.data.url
          })
        } else {
          if (!this.formData.productFile) {
            this.formData.productFile = []
          }
          this.formData.productFile.push({
            name: file.name,
            fileId: response.data.name,
            url: response.data.url
          })
        }
      }
    },
    // 方法
    getCountry() {
      request({
        url: `/api/base/Country/GetAll`,
        method: 'GET',
        headers: {
          Authorization: this.token
        }
      }).then(res => {
        this.countryList = res.data
      })
    },
    init(id) {
      this.formData.id = id || 0
      this.visible = true
      this.$nextTick(() => {
        this.$refs['formData'].resetFields()
        if (this.formData.id) {
          request({
            url: '/api/crm/CustomerCommodity/' + this.formData.id,
            method: 'get',
            headers: {
              Authorization: this.token
            }
          }).then(res => {
            this.formData = res.data
          })
        }
      })
    },
    clickSave() {
      // 表单校验
      this.$emit('save', true)
      this.$refs['formData'].validate((val) => {
        if (val) {
          this.btnLoading = true
		  this.formData.productImage = JSON.stringify(this.formData.productImage)
		  this.formData.productFile = JSON.stringify(this.formData.productFile)
          if (!this.formData.id) {
            request({
              url: `/api/crm/CustomerCommodity`,
              method: 'post',
              data: this.formData,
              headers: {
                Authorization: this.token
              }
            }).then((res) => {
              this.btnLoading = false
              this.$emit('save', res.data)
            }).finally(() => {
              this.btnLoading = false
            })
          } else {
            request({
              url: '/api/crm/CustomerCommodity/' + this.formData.id,
              method: 'PUT',
              data: this.formData,
              headers: {
                Authorization: this.token
              }
            }).then((res) => {
              this.btnLoading = false
              this.$emit('save', res.data)
            }).finally(() => {
              this.btnLoading = false
            })
          }
        }
      })
    },
    clickCancel() {
      this.$emit('close', false)
    }
  }
}
</script>
<style scoped lang='scss'>
	.commodities {
		height: auto;
		background: #ffffff;
		border-radius: 8px;
		padding: 0 16px 16px;

		.commodities-title {
			height: 56px;
			font-size: 18px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 600;
			color: #333333;
			line-height: 56px;
			text-align: left;
			border-bottom: 1px solid #DDDDDD;
		}

		.new_inquiry_header {
			width: auto;
			display: flex;
			flex-wrap: wrap;

			.el-form-item--medium:nth-of-type(3),
			.el-form-item--medium:nth-of-type(8) {
				width: 100%; //calc(99% - 28px);
			}
		}
	}

	.item-Surcharge {
		width: 100%;
		background: #fff;
		border-radius: 8px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;

		.item-Surcharge_search {
			display: flex;
			margin-bottom: 16px;
			flex-wrap: wrap;
			width: auto;
			justify-content: space-between;

			.search-flex-item {
				display: flex;
				align-items: baseline;
				margin-right: 16px;
			}

			.search-type {
				width: calc(100% - 65px);

				& ::v-deep .el-input__inner {
					height: 32px !important;
					line-height: 32px !important;
				}

				& ::v-deep .el-select__caret {
					line-height: 32px !important;
				}
			}

			.mr6 {
				margin-right: 6px;
			}

			.search-label {
				width: 80px;
				display: block;
				font-size: 13px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				line-height: 18px;
			}

			.reset-radio-group {
				border-radius: 4px;

				& ::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
					background: rgba(0, 70, 185, 0.04);
					border-color: #0046b9;
					color: #0046b9;
					box-sizing: border-box;

					// &:nth-child(1) {
					//   border-radius: 4px 0px 0px 4px;
					// }

					// &:last-child {
					//   border-radius: 0px 4px 4px 0px;
					// }
				}

				& ::v-deep .el-radio-button__inner {
					display: inline-block;
					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #777;

					&:hover {
						color: #0046b9;
					}

					// line-height: 22px;
				}

				& ::v-deep .el-radio-button--small .el-radio-button__inner {
					padding: 8px 16px;
				}
			}

			.search-left {
				flex: 1;
			}
		}
	}

	.el-select {
		width: 100%;
	}

	.el-form-item--medium {
		width: 48%;
		float: left;
		text-align: left;
		margin-bottom: 0px !important;

		.el-form-item__label {
			line-height: 8px !important;
			padding: 0px 0px 7px 0 !important;
			margin-top: 18px !important;
		}

		.input-Lowest {
			display: flex;

			.el-radio-group {
				width: 120px;
			}

			.el-input__inner {
				width: 60px;
				margin-left: 12px;
			}

			.el-input {
				width: 60px !important;
			}
		}

		.el-radio-group {
			display: flex;
			margin-top: 8px;

			//width: 200px;
			label:nth-of-type(1) {
				margin-right: 20px !important;
			}

			label:nth-of-type(3) {
				margin-left: 10px !important;
			}
		}

		.el-radio__input.is-checked .el-radio__inner {
			border-color: #0046b9;
			background: #0046b9;
		}

		.el-radio__input.is-checked+.el-radio__label {
			color: #0046b9;
		}

		.el-input {
			.el-input__inner {
				border-radius: 4px;
				border: 1px solid #dcdcdc;
				height: 40px;
				line-height: 32px;
				padding-left: 8px;
				font-size: 13px;
				font-family: "PingFangSC-Regular", "Microsoft YaHei", sans-serif;
				font-weight: 500;
				color: #333333;

				&:hover {
					border: 1px solid #999999;
				}

				&:focus {
					border: 1px solid #0046b9;
				}
			}
		}
	}

	.upload-class {
		height: 72px;
		background: rgba(153, 153, 153, 0.06);
		border-radius: 8px;
		border: 1px dashed rgba(153, 153, 153, 0.56);
		display: flex;
		justify-content: space-between;
		align-items: center;
		cursor: pointer;

		.upload-label {
			flex: 1;
			font-size: 14px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;

			span:nth-of-type(1) {
				color: #333333;
			}

			span:nth-of-type(2) {
				color: #aaaaaa;
			}
		}

		img:nth-of-type(1) {
			margin: 24px 16px 24px 24px;
		}

		img:nth-of-type(2) {
			//float: right;
			//flex: 1;
			//margin-right: -20px;
		}
	}

	.foot-button-manage {
		font-size: 16px;
		margin-top: 33px;

		button {
			width: 160px;
			height: 40px;
			margin-left: 24px;
		}
	}
</style>
